import React, { useEffect } from 'react';
import Footer from '../../components/Footer';
import { Helmet } from "react-helmet-async";
import { Link } from 'react-router-dom';
import { BILIRKISI_FEES } from '../../constants/constants';
import Header from '../../components/Header';

const faqs = [
    {
        question: "Bilirkişi Asgari Tarifesi, bilirkişilerin yapmış oldukları çalışmalar karşılığında alabilecekleri asgari ücretleri düzenleyen bir tarifedir. Bu tarife, Adalet Bakanlığı tarafından her yıl güncellenmektedir.",
    },
    {
        question: "<h5>Bilirkişi Asgari Tarifesi Neleri Kapsar?</h5><p>Bilirkişi Asgari Tarifesi, aşağıdakileri kapsar:</p>",
        answer: ["Bilirkişi incelemesi için gerekli olan keşif ve araştırma ücretleri", "Bilirkişi raporunun hazırlanması için gerekli olan zaman ve emek", "Bilirkişinin uzmanlık alanı ve deneyimi"],
    },
    {
        question: "<h5>Bilirkişi Asgari Tarifesi Nasıl Belirlenir?</h5><p>Bilirkişi Asgari Tarifesi, aşağıdaki unsurlar göz önünde bulundurularak belirlenir:</p>",
        answer: ["Bilirkişinin uzmanlık alanı", "Bilirkişinin deneyimi", "Bilirkişi incelemesinin karmaşıklığı", "Bilirkişi incelemesi için gerekli olan zaman ve emek"],
    },
    {
        question: "<h5>Bilirkişi Ücreti Ne Kadar?</h5>",
        answer: ["Bilirkişi ücreti, Bilirkişi Asgari Tarifesi'nde belirlenen asgari ücretten az olamaz. Ancak, bilirkişi ve taraflar arasında daha yüksek bir ücret üzerinde anlaşmaya varılabilir."],
    },
    {
        question: "<h5>Bilirkişi Ücretini Kim Öder?</h5>",
        answer: ["Bilirkişi ücretini, bilirkişi incelemesini talep eden taraf öder."],
    },
    {
        question: "<h5>Bilirkişi Ücreti Nasıl Ödenir?</h5>",
        answer: ["Bilirkişi ücreti, peşin veya taksitle ödenebilir."],
    },
    {
        question: "<h5>Bilirkişi Ücretine İtiraz Hakkı</h5>",
        answer: ["Taraflar, bilirkişi ücretine itiraz etme hakkına sahiptir. İtiraz, bilirkişi raporunun sunulduğu mahkemeye yapılmalıdır."],
    },
];

const BilirkisiAsgariTarifeleri = () => {
	useEffect(() => {		
		localStorage.setItem('referrer', `${window.location.origin}${window.location.pathname}`);
	});

    return (
        <>
            <Helmet>
                <title>Bilirkişi Asgari Tarifeleri - Legalbul</title>
                <link rel="canonical" href={`${window.location.origin}${window.location.pathname}`} />
                <meta name="description" content="Bilirkişi asgari tarifesi, mahkemelerde bilirkişi raporu hazırlamak üzere atanmış uzmanların alacakları asgari ücretleri belirleyen bir düzenlemedir." />
            </Helmet>
            
            <Header />
            <section className="container my-5 bg-white shadow-sm p-0">
                <div className="p-4">
                    <ol className="breadcrumbnav">
                        <li>
                            <Link to="/">Ana Sayfa</Link>
                        </li>
                        <li>
                            <Link to="/hesaplamalar">Tüm Hesaplamalar</Link>
                        </li>
                        <li>
                            Bilirkişi Asgari Tarifeleri
                        </li>
                    </ol>
                    <h1 className="fw-semibold">Bilirkişi Asgari Tarifeleri</h1>
                    <p>Bilirkişi asgari tarifesi, mahkemelerde bilirkişi raporu hazırlamak üzere atanmış uzmanların alacakları asgari ücretleri belirleyen bir düzenlemedir.</p>
                
                    <table className="table table-bordered table-hover">
                        <thead>
                            <tr>
                                <th>Tür</th>
                                <th>Ücret (TL)</th>
                            </tr>
                        </thead>
                        <tbody>
                            {BILIRKISI_FEES.map((item, index) => (
                                <tr key={index}>
                                    <td>{item.type}</td>
                                    <td>{item.amount}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </section>
            
            <Footer faqs={faqs} faqTitle="Bilirkişi Asgari Tarifeleri Hakkında Bilmeniz Gerekenler" />
        </>
    );
};

export default React.memo(BilirkisiAsgariTarifeleri);
